const databaseURL_shared = "https://aste-seriea-dev-1.europe-west1.firebasedatabase.app" // "https://aste-seriea-dev-shared.europe-west1.firebasedatabase.app"
const databaseURL = false; // "https://aste-seriea-dev-1.europe-west1.firebasedatabase.app"

const firebaseConfig = {
  apiKey: "AIzaSyALD0bNzwzMvSEapJ1nFaxo3Q4dKCE05ZA",
  authDomain: "dev-aste-fantacalcio.com",
  databaseURL: databaseURL_shared,
  projectId: "aste-standalone-dev",
  storageBucket: "aste-standalone-dev.appspot.com",
  messagingSenderId: "482712267334",
  appId: "1:482712267334:web:9f2362d6852664f47cf847",
  measurementId: "G-68NGLC8D8S"
};

export {
  firebaseConfig,
  databaseURL_shared,
  databaseURL,
}

